import React, { memo } from 'react';
import { Calendar, MapPin } from 'lucide-react';
import { SEO } from '../components/layout/SEO';
import { Section } from '../components/ui/Section';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { FadeIn } from '../components/ui/FadeIn';
import { Carousel } from '../components/ui/Carousel';
import { Link } from 'react-router-dom';
export function EventsPage() {
  const manchester2019Images = ['https://cdn.magicpatterns.com/uploads/oGukBTTXfCqy9gm1qmVrBT/Manch_2019.jpg', 'https://cdn.magicpatterns.com/uploads/3a7zPu6FsZD3QZuMifQqWh/Manch_2019_2.jpg', 'https://cdn.magicpatterns.com/uploads/3ZKbxcqPfDemcoM5bdwgrx/Manch_20193.jpg', 'https://cdn.magicpatterns.com/uploads/9tzLjG4kA4tWpZ3iCuiPcJ/Manch_20194.jpg'];
  const dublin2015Images = ['https://cdn.magicpatterns.com/uploads/ucMDpzUy5uaM6pXGEBW61u/dublin_2015.jpg', 'https://cdn.magicpatterns.com/uploads/aAAJUDz6bA8bhbNR5Bs1MH/dublin_2015_2.jpg', 'https://cdn.magicpatterns.com/uploads/jdjxGq7oQ8eoum72XpfYgy/dublin_2015_3.jpg', 'https://cdn.magicpatterns.com/uploads/p46gaVzdRapCmcSYkXYigu/dublin_2015_4.jpg', 'https://cdn.magicpatterns.com/uploads/9H3KdpyKAsdDc6MeS7zSEq/dublin_2015_5.jpg', 'https://cdn.magicpatterns.com/uploads/uHkX2EUtFbt8bDgCZb4TrE/dublin_2015_6.jpg', 'https://cdn.magicpatterns.com/uploads/7nqRUVr1jVwM9yRvDPujt7/dublin_2015_7.jpg', 'https://cdn.magicpatterns.com/uploads/tK1Bk53e8BYmNqkrJjYye7/dublin_2015_8.jpg', 'https://cdn.magicpatterns.com/uploads/wkE7TeNNJ6j39HBeGKG7mf/dublin_2015_9.jpg'];
  const manchester2025Images = ['https://cdn.magicpatterns.com/uploads/6RzUH7U143ATETBpMwZLzs/manchester.jpg', 'https://cdn.magicpatterns.com/uploads/tK1Bk53e8BYmNqkrJjYye7/dublin_2015_8.jpg', 'https://cdn.magicpatterns.com/uploads/wkE7TeNNJ6j39HBeGKG7mf/dublin_2015_9.jpg'];
  const manchester2014Images = ['https://cdn.magicpatterns.com/uploads/7Ee1ZcTYzov1FS9EbGfAb6/Manchester_2014.jpg', 'https://cdn.magicpatterns.com/uploads/t3TmZKyAoyGkLJUqqwf7RV/Manchester_2014_1.jpg', 'https://cdn.magicpatterns.com/uploads/5GhiBueVuevKmE89A4uPzR/Manchester_2014_2.jpg', 'https://cdn.magicpatterns.com/uploads/evi9GDpWZ2vmbgTiWSJ8Q7/Manchester_2014_3.jpg'];
  const pastEvents = [{
    title: 'Manchester 2025',
    date: 'October 18th, 2025',
    venue: 'My Nawab, Stockport Road',
    description: 'AGM and social networking event. New members enrolled. Elections held and new KMA Council elected. Cultural music and entertainment.',
    images: manchester2025Images
  }, {
    title: 'Manchester 2019',
    date: 'September 21st, 2019',
    venue: 'Sheridan Suite, Manchester',
    description: 'Annual gala and cultural event. Members from UK and Ireland with families attended. AGM held. Great atmosphere prior to Covid19.',
    images: manchester2019Images
  }, {
    title: 'Dublin 2015',
    date: 'July 2015 (Dublin), August 2015 (Manchester)',
    venue: "Dublin and Karim's Manchester",
    description: 'Annual gala in Dublin Ireland. ENT professor and teacher Dr Muhibullah chief guest, memorable food and music. Second get together in Manchester.',
    images: dublin2015Images
  }, {
    title: 'Manchester 2014',
    date: '2014',
    venue: "Karim's, Middleton, Manchester",
    description: 'Annual meeting, awards ceremony to appreciate the work and academic achievements of members, live entertainment and socialising evening.',
    images: manchester2014Images
  }];
  return <>
      <SEO title="Events" description="Join us for professional networking, cultural celebrations, and community building events" data-id="element-376" />

      <div className="bg-[#1e5f4f] text-white py-12 md:py-16" data-id="element-377">
        <div className="container mx-auto px-4 text-center" data-id="element-378">
          <FadeIn data-id="element-379">
            <Calendar className="h-12 w-12 mx-auto mb-4 text-white" data-id="element-380" />
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-3 text-white" data-id="element-381">
              Events & Gatherings
            </h1>
            <p className="text-xl text-white max-w-2xl mx-auto" data-id="element-382">
              Join us for professional networking, cultural celebrations, and
              community building events throughout the year.
            </p>
          </FadeIn>
        </div>
      </div>

      {/* Past Events */}
      <Section data-id="element-383">
        <div className="max-w-4xl mx-auto mb-8" data-id="element-384">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-2 text-left" data-id="element-385">
            Past Events
          </h2>
          <p className="text-gray-600 text-left" data-id="element-386">
            A look back at our gatherings and community activities over the
            years.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-387">
          {pastEvents.map((event, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-388">
              <Card className="flex flex-col overflow-hidden shadow-md hover:shadow-lg transition-shadow h-full" data-id="element-389">
                <div className="p-5 pb-3" data-id="element-390">
                  <Carousel images={event.images} alt={event.title} height="card" data-id="element-391" />
                </div>
                <CardContent className="p-5 pt-2 flex-1 flex flex-col" data-id="element-392">
                  <h3 className="text-2xl font-serif font-bold text-gray-900 mb-2" data-id="element-393">
                    {event.title}
                  </h3>
                  <p className="text-accent-700 font-semibold mb-3 flex-1 min-h-[60px]" data-id="element-394">
                    {event.description}
                  </p>
                  <div className="space-y-1 text-sm text-gray-600 mt-auto" data-id="element-395">
                    <div className="flex items-start gap-2" data-id="element-396">
                      <Calendar className="h-4 w-4 text-gray-400 shrink-0 mt-0.5" data-id="element-397" />
                      <span data-id="element-398">{event.date}</span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-399">
                      <MapPin className="h-4 w-4 text-gray-400 shrink-0 mt-0.5" data-id="element-400" />
                      <span data-id="element-401">{event.venue}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </FadeIn>)}
        </div>
      </Section>

      {/* Member Benefits CTA */}
      <Section background="gray" className="text-center" data-id="element-402">
        <FadeIn data-id="element-403">
          <div className="max-w-3xl mx-auto" data-id="element-404">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-3" data-id="element-405">
              Don't Miss Out on Future Events
            </h2>
            <p className="text-gray-600 mb-6 text-lg" data-id="element-406">
              KMA UK members receive priority notification and exclusive access
              to all our events, seminars, and networking opportunities.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-407">
              <Link to="/membership" data-id="element-408">
                <Button size="lg" data-id="element-409">Join KMA UK Today</Button>
              </Link>
              <Link to="/about" data-id="element-410">
                <Button variant="outline" size="lg" data-id="element-411">
                  Learn More About Us
                </Button>
              </Link>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
}